import { useState } from 'react';
import { ModalComponent } from '../baseComponents';
import { useDispatch, useSelector } from 'react-redux';
import { updateIntakeSummaryFeedback } from 'src/store/actions/appointment.action';
import * as Yup from 'yup';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

export const FeedbackForm = ({
  isOpen,
  onCancel,
  setIsOpen,
  feedbackScore,
}) => {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { getUuid } = useSelector((state) => state?.appointmentState);
  const validationSchemaField =
    feedbackScore === 0
      ? Yup.object().shape({
          comment: Yup.string().required('Comment is required'),
        })
      : '';
  const initialValues = {
    comment: '',
    appointment_id: getUuid?.appointment_details?.appointment_id,
    score: feedbackScore,
  };
  const [submitLoading, setSubmitLoading] = useState(false);

  const sections = [
    {
      heading: 'Provide additional feedback',
      className: '',
      fields: [
        {
          name: 'comment',
          type: 'textarea',
          placeholder:
            feedbackScore === 0
              ? 'How can we improve?'
              : 'How can we improve? (Optional) ',
          rows: 6,
        },
      ],
    },
  ];

  return (
    <ModalComponent
      open={isOpen}
      className={'feedback-modal'}
      validationSchema={validationSchemaField}
      initialValues={initialValues}
      sections={sections}
      submitButtonText="Submit"
      cancelButtonText=""
      submitLoading={submitLoading}
      handleCancel={() => {
        onCancel();
        setSubmitLoading(false);
      }}
      handleSubmit={(values) => {
        setSubmitLoading(true);
        analytics.track('Feedback Provided CareConnect Summary', {
          appointment_date: getUuid?.appointment_details?.created_at,
          email: user?.email,
          appointment_id: getUuid?.appointment_details?.appointment_id,
          appointment_status:
            getUuid?.appointment_details?.chat_completion_status,
          feedback: values?.comment,
          practitioner_name: `${getUuid?.appointment_details?.practitioner_firstName} ${getUuid?.appointment_details?.practitioner_last_name}`,
        });
        dispatch(
          updateIntakeSummaryFeedback(values, setIsOpen, setSubmitLoading)
        );
      }}
    />
  );
};
